/* global axios */
import ApiClient from '../ApiClient';

class CaptainDisputes extends ApiClient {
  constructor() {
    super('captain/disputes', { accountScoped: true });
  }

  getSummary() {
    return axios.get(this.url);
  }
}

export default new CaptainDisputes();
